export default __webpack_public_path__ + "static/media/logo_tagline@4x_1.25bae670.svg";